module.exports = {"230623100":"林甸镇","230623101":"红旗镇","230623102":"花园镇","230623103":"四季青镇","230623104":"鹤鸣湖镇","230623200":"东兴乡","230623201":"宏伟乡","230623204":"四合乡","230623400":"林甸县长青林场","230623500":"巨浪牧场","230623580":"国营苇场","230623581":"新兴畜牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230623.json
// module id = 681
// module chunks = 0